import React from "react";
import {
    MDBModal,
    MDBModalHeader,
    MDBModalBody,
    MDBIcon,
    MDBModalFooter,
    MDBBtn,
    MDBRow,
    MDBCol,
    MDBTable,
} from "mdbreact";
import { formatHumansBs } from "../../helpers/formatHuman";

class ModalOrderDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <MDBModal
                size="lg"
                className=""
                isOpen={this.props.modalStateOrderDetails}
                backdrop={true}
                toggle={() => {
                    this.props.changeStateModalOrderDetails();
                }}
            >
                <MDBModalHeader
                    tag="p"
                    titleClass="heading lead"
                    className="bg-tertiary-personalize"
                >
                    <i className="fa fa-shopping-cart text-white"></i>{" "}
                    <span className="font-weight-bold text-white">
                        Detalle Pedido
                    </span>
                </MDBModalHeader>
                <MDBModalBody className="text-center">
                    <MDBRow>
                        <MDBCol md="12">
                            <MDBTable responsive hover>
                                <thead>
                                    <tr>
                                        <th className="th-lg font-weight-bold">
                                            Producto
                                        </th>
                                        <th className="th-lg font-weight-bold">
                                            Precio
                                        </th>
                                        <th className="th-lg font-weight-bold">
                                            Cantidad
                                        </th>
                                        <th className="th-lg font-weight-bold">
                                            Total
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.listaDetallePedido.map(
                                        (detallePedido) => (
                                            <tr>
                                                <td>
                                                    {detallePedido.producto}
                                                </td>
                                                <td>
                                                    {formatHumansBs(
                                                        detallePedido.precio
                                                    )}
                                                </td>
                                                <td>
                                                    {parseInt(
                                                        detallePedido.cantidad
                                                    )}
                                                </td>
                                                <td>
                                                    {formatHumansBs(
                                                        detallePedido.total
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </MDBTable>
                        </MDBCol>
                    </MDBRow>
                </MDBModalBody>
                <MDBModalFooter right>
                    <button
                        type="button"
                        style={{
                            padding: "0",
                            margin: "0",
                            height: "auto",
                        }}
                        className="bg-tertiary-personalize rounded-sm text-white py-2 px-4"
                        onClick={() => {
                            this.props.changeStateModalOrderDetails();
                        }}
                    >
                        Cerrar
                    </button>
                </MDBModalFooter>
            </MDBModal>
        );
    }
}
export default ModalOrderDetails;
